export default __webpack_public_path__ + "static/media/lan-3.a6be117b.jpg";